import { useEffect, useState } from "react";
import { format, parseISO, subDays } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Calendar } from "./ui/calendar";

const toISO = (d) => format(d, "yyyy-MM-dd");

export const AvailabilityCalendar = ({ property, booked, checkin, checkout, onChange }) => {
  const seasonRanges = (property.season_prices || []).map((s) => ({ from: parseISO(s.start), to: parseISO(s.end) }));
  const bookedRanges = booked.map((b) => ({ from: parseISO(b.checkin), to: subDays(parseISO(b.checkout), 1) }));
  const [month, setMonth] = useState(parseISO(checkin));
  useEffect(() => setMonth(parseISO(checkin)), [checkin]);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const onDayClick = (day, mods) => {
    if (mods.disabled) return;
    const iso = toISO(day);
    if (checkout || iso <= checkin) onChange(iso, null);
    else onChange(checkin, iso);
  };

  return (
    <div className="mb-4 rounded-2xl border border-slate-200 bg-slate-50/60" data-testid="availability-calendar">
      <Calendar
        mode="range"
        month={month}
        onMonthChange={setMonth}
        locale={ptBR}
        selected={{ from: parseISO(checkin), to: checkout ? parseISO(checkout) : undefined }}
        onDayClick={onDayClick}
        classNames={{
          cell: "relative p-0 text-center text-sm [&:has([aria-selected])]:bg-blue-50 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md [&:has(>.day-range-end)]:rounded-r-md",
          day_selected: "!bg-[#0A66C2] !text-white hover:!bg-[#0A66C2]",
          day_range_middle: "aria-selected:!bg-blue-50 aria-selected:!text-[#0A66C2]",
          day_today: "font-extrabold underline",
        }}
        disabled={[{ before: today }, ...bookedRanges]}
        modifiers={{ booked: bookedRanges, season: seasonRanges }}
        modifiersClassNames={{ booked: "!bg-red-100 !text-red-500 line-through !opacity-100", season: "ring-1 ring-inset ring-amber-400" }}
        className="mx-auto w-fit"
      />
      <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 px-2 pb-3 text-[11px] font-semibold text-slate-500">
        <span className="flex items-center gap-1.5"><i className="w-3 h-3 rounded bg-white border border-slate-300" /> Livre</span>
        <span className="flex items-center gap-1.5"><i className="w-3 h-3 rounded bg-red-100 border border-red-300" /> Ocupado</span>
        <span className="flex items-center gap-1.5"><i className="w-3 h-3 rounded bg-[#0A66C2]" /> Sua escolha</span>
        {seasonRanges.length > 0 && <span className="flex items-center gap-1.5"><i className="w-3 h-3 rounded ring-1 ring-amber-400" /> Temporada</span>}
      </div>
    </div>
  );
};
